import { MenuItem, MenuItemCommandParams } from "primereact/menuitem";
import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { UserInfo } from "../../../WSUtils/UserInfo";
import {
  IWsRoutePath,
  routerStore,
  wsRouteMatch,
} from "../../../WSUtils/WSRouter";
import { concatClassnames } from "../../../WSUtils/util";

export interface CustomMenuItem extends MenuItem {
  path?: string;
  label: string;
  icon: string;
  className?: string;
  onClick?: (
    evt: MenuItemCommandParams["originalEvent"],
    userInfo: UserInfo,
    menuItem: CustomMenuItem
  ) => Promise<void> | void;
  isSelected?: () => boolean;
}

export const isPathSelected = (path: IWsRoutePath) =>
  wsRouteMatch(path, routerStore.location.pathname);

export const getItem = (item: CustomMenuItem, userInfo: UserInfo): MenuItem => {
  const { href, target, onClick } = getRedirectProps(item.path, {
    userInfo,
    mergeQs: {},
  });

  const isSelected = item.isSelected
    ? item.isSelected()
    : isPathSelected(item.path);

  return {
    label: item.label,
    icon: item.icon,
    className: isSelected
      ? `active ${concatClassnames([item.className])}`
      : concatClassnames([item.className]),

    command: (params) => {
      if (item.onClick) {
        return item.onClick(params.originalEvent, userInfo, item);
      }
      return onClick(params.originalEvent);
    },
    url: href,
    target,
  };
};
